import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Grid, Key, Shield, Paintbrush, Hammer } from 'lucide-react';
import './ServicesGrid.css';

const SERVICES = [
  {
    icon: <Grid size={28} />,
    title: 'Window Repair',
    desc: "Cracked pane? Drafty frame? We restore windows quickly and professionally — don't replace what can be repaired.",
    cta: 'Learn More',
    to: '/window-repair',
    highlight: true,
  },
  {
    icon: <Shield size={28} />,
    title: 'Screen Repair',
    desc: 'Torn or missing window and door screens replaced fast. Bring it in or ask about our in-store service.',
    cta: 'Learn More',
    to: '/services',
  },
  {
    icon: <Key size={28} />,
    title: 'Key Cutting',
    desc: 'Fast, accurate key duplication for home, auto, and padlocks. Most keys cut while you wait.',
    cta: 'Learn More',
    to: '/services',
  },
  {
    icon: <Paintbrush size={28} />,
    title: 'Paint Matching',
    desc: "We match any color, any brand. Bring in a chip, a lid, or a photo and we'll mix it on the spot.",
    cta: 'Learn More',
    to: '/services',
  },
  {
    icon: <Wrench size={28} />,
    title: 'Tools & Supplies',
    desc: 'Hand tools, power tools, fasteners, and everyday hardware — everything the job requires, in one stop.',
    cta: 'Shop Now',
    to: '/services',
  },
  {
    icon: <Hammer size={28} />,
    title: 'Hardware & Fasteners',
    desc: 'Bolts, screws, anchors, and specialty hardware stocked deep. If we have it, we have what you need.',
    cta: 'Shop Now',
    to: '/services',
  },
];

function ServicesGrid() {
  return (
    <section className="services-grid">
      <div className="container services-grid__inner">
        <div className="services-grid__header">
          <h2 className="services-grid__heading">What We Do</h2>
          <p className="services-grid__sub">Practical help for projects big and small. Reliable supplies and trusted local service.</p>
        </div>

        <div className="services-grid__grid">
          {SERVICES.map((s) => (
            <div key={s.title} className={`service-card${s.highlight ? ' service-card--highlight' : ''}`}>
              <div className="service-card__icon">{s.icon}</div>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__desc">{s.desc}</p>
              <Link to={s.to} className="service-card__cta">
                {s.cta} →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesGrid;
